import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { RenaultMyServiceActionDTO, RenaultMyServiceActionModelList, RenaultMyServiceActionPriceDTO, RenaultMyServiceActionRemunerationModel, RenaultMyServiceActionResult, RenaultMyServiceProductTypeDTO } from '../models/renault-myservice-dto';
import { DistributorParams } from '../models/shared-dto';

@Injectable({
  providedIn: 'root'
})

export class MyServiceService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultMyService/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<RenaultMyServiceActionDTO> {
    return this.http.get<RenaultMyServiceActionDTO>(this.pathAPI + this.controller + id);
  }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable', data);
  }

  public getDataTableMyZone(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableMyZone', data);
  }

  public post(data: RenaultMyServiceActionDTO): Observable<RenaultMyServiceActionDTO> {
    return this.http.post<RenaultMyServiceActionDTO>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: RenaultMyServiceActionDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public GetProductType(id: string): Observable<RenaultMyServiceProductTypeDTO[]> {
    return this.http.get<RenaultMyServiceProductTypeDTO[]>(this.pathAPI + this.controller + 'GetProductType/' + id);
  }

  public GetActionPrice(idAction: string, idProductType): Observable<RenaultMyServiceActionPriceDTO[]> {
    return this.http.get<RenaultMyServiceActionPriceDTO[]>(this.pathAPI + this.controller + 'GetActionPrice/' + idAction + '/' + idProductType);
  }

  public GetActionResult(IdAction: string, filter: DistributorParams): Observable<RenaultMyServiceActionResult> {
    return this.http.post<RenaultMyServiceActionResult>(this.pathAPI + this.controller + 'GetActionResult/' + IdAction, filter);
  }

  public InsertActionPrice(data: RenaultMyServiceActionPriceDTO): Observable<RenaultMyServiceActionPriceDTO> {
    return this.http.post<RenaultMyServiceActionPriceDTO>(this.pathAPI + this.controller + 'InsertActionPrice', data);
  }

  public delete(id: string): Observable<any> {
    return this.http.delete<any>(this.pathAPI + this.controller + id);
  }

  public GetUserAction(): Observable<RenaultMyServiceActionModelList> {
    return this.http.get<RenaultMyServiceActionModelList>(this.pathAPI + this.controller + 'GetUserAction');
  }

  public GetUserRemuneration(idAction: string): Observable<RenaultMyServiceActionRemunerationModel> {
    return this.http.get<RenaultMyServiceActionRemunerationModel>(this.pathAPI + this.controller + 'GetUserRemuneration/' + idAction);
  }

  getMyServiceActionExcel(idAction: string): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetActionResultExcel/' + idAction;
    return this.http.post<Blob>(endpoint, null, requestOptions);
  }

  getMyServiceContractExcel(): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetContractExcel/';
    return this.http.post<Blob>(endpoint, null, requestOptions);
  }


  public approveMyServiceActionLegal(id: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + "ApproveMyServiceActionLegal/" + id);
  }


  public ReloadContractHistoric(IdAction: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'SetContractHistoric/' + IdAction);
  }

}
